import { render, staticRenderFns } from "./TicketDownload.vue?vue&type=template&id=52ee49f2&scoped=true&"
import script from "./TicketDownload.vue?vue&type=script&lang=ts&"
export * from "./TicketDownload.vue?vue&type=script&lang=ts&"
import style0 from "./TicketDownload.vue?vue&type=style&index=0&id=52ee49f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee49f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ee49f2')) {
      api.createRecord('52ee49f2', component.options)
    } else {
      api.reload('52ee49f2', component.options)
    }
    module.hot.accept("./TicketDownload.vue?vue&type=template&id=52ee49f2&scoped=true&", function () {
      api.rerender('52ee49f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/tickets/TicketDownload.vue"
export default component.exports